import { render } from "./float-bg.vue?vue&type=template&id=5901c9ee&scoped=true"
import script from "./float-bg.vue?vue&type=script&lang=js"
export * from "./float-bg.vue?vue&type=script&lang=js"

import "./float-bg.vue?vue&type=style&index=0&id=5901c9ee&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/_DKRx8o2/0/web/speechki_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5901c9ee"]])

export default __exports__